import Stack, { StackProps } from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export interface HostingDetailsDescriptionProps extends StackProps {
	serverDescription?: string | null;
}

const HostingDetailsDescription = ({
	serverDescription,
	sx,
	...rest
}: HostingDetailsDescriptionProps) => {
	return (
		<Stack
			sx={combineSx(
				{
					gap: 100,
				},
				sx,
			)}
			{...rest}
		>
			{serverDescription && (
				<Typography variant="body-md">{serverDescription}</Typography>
			)}
		</Stack>
	);
};

export default HostingDetailsDescription;
